module.exports = __webpack_public_path__ + "static/media/relearn.8f7363af.PNG";